'use client';

import { useEffect } from 'react';
import { useLocale } from 'next-intl';
import { getHurraLanguage } from '@/libs/helper/hurraLanguage';

/**
 * Component that synchronizes the Hurra consent banner language with the current page locale.
 * This component runs on the client side and updates window.hc_consent_default_lang
 * whenever the locale changes.
 *
 * Note: For initial page load, the language is set via an inline script in layout.tsx
 * to ensure it runs before the Hurra script loads.
 */
export default function ConsentLanguageSync() {
    const locale = useLocale();

    useEffect(() => {
        const hurraLang = getHurraLanguage(locale);
        window.hc_consent_default_lang = hurraLang;
    }, [locale]);

    return null;
}

